module.exports = __webpack_public_path__ + "img/eyeDodIcon.21d5f279.svg";